import React, { FC } from 'react';

type Props = {
  text?: string;
  className?: string;
};

const PageLoader: FC<Props> = ({ text = 'Loading...', className = '' }) => {
  return (
    <div
      className={`flex h-full items-center justify-center text-center min-h-[300px] ${className}`}>
      {text}
    </div>
  );
};

export default PageLoader;
